/* unplugin-vue-components disabled */// extracted by mini-css-extract-plugin
export default {"bar":"bar-beccc0"};